<template>
  <div class="left-sidebar">
    <!-- 各个一级分类的卡片 -->
    <div class="sidebar-card" v-for="cat in categoryTree" :key="cat.id">
      <div
        class="sidebar-card-header"
        @click="selectCategory(cat.id, cat.name)"
      >
        <div class="sidebar-indicator"></div>
        <div class="sidebar-title cursor-pointer">
          {{ cat.name }}
        </div>
      </div>
      <div
        class="sidebar-menu-items"
        v-if="cat.children && cat.children.length"
      >
        <div
          class="sidebar-menu-item"
          v-for="child in cat.children"
          :key="child.id"
          @click="selectCategory(child.id, child.name)"
        >
          <span class="menu-item-text">{{ child.name }}</span>
        </div>
      </div>

      <!-- 2-3级悬浮弹出大面板 -->
      <div
        class="category-hover-panel"
        v-if="cat.children && cat.children.length"
      >
        <div class="hover-panel-inner">
          <div
            class="hover-second-group"
            v-for="second in cat.children"
            :key="second.id"
          >
            <!-- 二级分类大标题（点击选中二级分类） -->
            <div
              class="hover-second-title"
              @click.stop="selectCategory(second.id, second.name)"
            >
              {{ second.name }}
            </div>
            <!-- 三级分类小字平铺（点击选中三级分类） -->
            <div
              class="hover-third-items"
              v-if="second.children && second.children.length"
            >
              <span
                class="hover-third-item"
                v-for="third in second.children"
                :key="third.id"
                @click.stop="selectCategory(third.id, third.name)"
              >
                {{ third.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategorySidebar",
  props: {
    // 分类树数据
    categoryTree: {
      type: Array,
      default: () => [],
    },
    // 当前激活的分类 ID
    classifyId: {
      type: [String, Number],
      default: "",
    },
  },
  methods: {
    /**
     * 向父组件派发选中分类事件
     * @param {string|number} id - 分类ID
     * @param {string} name - 分类名称
     * @returns {void}
     */
    selectCategory(id, name) {
      this.$emit("select", { id, name });
    },
  },
};
</script>

<style lang="less" scoped>
.left-sidebar {
  width: 288px;
  flex-shrink: 0;
  margin-right: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  z-index: 10; /* 提升侧边栏整体层级，压过右侧内容区 */
}

.sidebar-card {
  position: relative; /* 提供悬浮定位基准 */
  width: 100%;
  padding: 24px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;

  /* 悬浮触发面板显示 */
  &:hover {
    .category-hover-panel {
      opacity: 1;
      visibility: visible;
      transform: translateX(0);
    }
  }
}

/* 2-3级悬浮弹出面板 */
.category-hover-panel {
  position: absolute;
  left: 100%;
  top: 0;
  margin-left: 0;
  width: 500px;
  max-height: 480px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  box-sizing: border-box;
  z-index: 9999 !important;

  /* 隐藏状态 */
  opacity: 0;
  visibility: hidden;
  transform: translateX(-10px);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.hover-panel-inner {
  padding: 24px;
  max-height: 478px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;

  /* 滚动条 */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(186, 202, 198, 0.3);
    border-radius: 99px;
  }
}

.hover-second-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
}

.hover-second-title {
  font-size: 15px;

  line-height: 22px;
  color: #00161a;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #00d8c3;
  }
}

.hover-third-items {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding-left: 4px;
}

.hover-third-item {
  font-size: 12px;

  font-weight: 400;
  line-height: 18px;
  color: #6b7a77;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: #00d8c3;
  }
}

.sidebar-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  .sidebar-indicator {
    width: 6px;
    height: 24px;
    background: #00d8c3;
    border-radius: 9999px;
    flex-shrink: 0;
  }
  .sidebar-title {
    font-size: 16px;

    font-weight: 400;
    line-height: 28px;
    color: #333333;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.cursor-pointer {
      cursor: pointer;
      transition: color 0.3s;
      &:hover {
        color: #00d8c3;
      }
    }
    &.active {
      color: #00d8c3;
    }
  }
}

.sidebar-menu-items {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap; /* 锁定单行展示，其余溢出隐藏（在大浮窗内显示全量） */
  overflow: hidden;
  white-space: nowrap;
  gap: 8px;
  width: 100%;
  margin-top: 4px;
}

.sidebar-menu-item {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #6b7a77;
  cursor: pointer;
  transition: color 0.3s;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: #00d8c3;
  }

  /* 选项间分割竖线 */
  &:not(:last-child)::after {
    content: "|";
    margin-left: 8px;
    color: rgba(186, 202, 198, 0.4);
    pointer-events: none;
  }
}

.menu-item-text {
  max-width: 72px; /* 锁定最大宽度为 72px，刚好展示 4 个汉字或超长截断，保持秀雅单行效果 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
